module.exports = __webpack_public_path__ + "static/media/empwish.02373ad4.png";